// extracted by mini-css-extract-plugin
module.exports = {"photo":"Automotive_photo___wTZD","info":"Automotive_info__27aVw","step":"Automotive_step__3xB4W","wrapper":"Automotive_wrapper__Zrt_L"};